import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import { FieldList } from '../../';
import * as Api from 'api';

const copy = obj => (JSON.parse(JSON.stringify(obj)));

class JobForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    }
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(value, name) {
    let copy_state = copy(this.state);
    let entity = copy_state;
    let names = name.split('.');

    while(names.length > 1) {
      let name = names.shift();
      if(!entity[name]) {
        entity[name] = {};
      }
      entity = entity[name];
    }

    entity[names.shift()] = value;
    this.setState(copy_state);
  }
  componentDidMount() {
    Promise.all([
      Api.getTypes('job','lead_source'),
      Api.getTypes('job', 'category'),
      Api.getTypes('job', 'work_type'),
      Api.getTypes('job', 'trade')
    ]).then(results => {
      this.setState({
        source_options : results[0],
        category_options : results[1],
        work_type_options : results[2],
        trade_options : results[3]
      })
    });
    this.props.fetchFields('Job');

  }
  render() {
    const { available_filters } = this.props.jobs;
    let fields = (this.props.fields || []).map(field => {
      switch(field.name) {
        case 'lead_source':
          return { ...field, options: (this.state.source_options || []).map(({value}) => ({label : value, value}))}
        case 'category':
          return {
            ...field,
            options: [
              ...(this.state.category_options || [])
                .map(({value}) => ({label: value, value})),
              ...available_filters
                .filter(({type}) => type == 'category')
                .map(({value}) => ({ label : value, value }))]
          }
        case 'work_type':
          return {
            ...field,
            options: [
              ...(this.state.work_type_options || [])
                .map(({value}) => ({label: value, value})),
              ...available_filters
                .filter(({type}) => type == 'work_type')
                .map(({value}) => ({label : value, value}))
            ]
          };
        case 'trade':
          return {
            ...field,
            options: [
              ...(this.state.work_type_options || [])
                .map(({value}) => ({label: value, value})),
              ...available_filters
                .filter(({type}) => type == 'trade')
                .map(({value}) => ({label : value, value}))
            ]
          };
        default:
          return field;
      }
    });
    // let fields = [
    //   {
    //     group : 'General Information',
    //     _id : 0,
    //     flex : 4,
    //     label : 'Lead Source',
    //     name : 'lead_source',
    //     type : 'select',
    //     options : (this.state.source_options || []).map(({value}) => ({label : value, value})),
    //     placeholder : 'Select Lead Source',
    //   },
    //   {
    //     group : 'General Information',
    //     _id: 1,
    //     flex: 4,
    //     label: 'Category',
    //     name: 'category',
    //     type: 'select',
    //     options: [...(this.state.category_options || []).map(({value}) => ({label: value, value})), ...available_filters
    //       .filter(({type}) => type == 'category')
    //       .map(({value}) => ({ label : value, value }))],
    //     placeholder: 'Select Job Category'
    //   }, {
    //     group : 'General Information',
    //     _id: 2,
    //     flex: 4,
    //     label: 'Work Type',
    //     name: 'work_type',
    //     type: 'multiselect',
    //     options: [...(this.state.work_type_options || []).map(({value}) => ({label: value, value})),...available_filters
    //       .filter(({type}) => type == 'work_type')
    //       .map(({value}) => ({label : value, value}))],
    //     placeholder: 'Select Work Type'
    //   }, {
    //     group : 'General Information',
    //     _id : 3,
    //     flex : 4,
    //     label : 'Trade',
    //     name : 'trade',
    //     type : 'multiselect',
    //     placeholder: 'Select a trade.',
    //     options : [...(this.state.trade_options || []).map(({value}) => ({label: value, value})), ...available_filters
    //       .filter(({type}) => type == 'trade')
    //       .map(({value}) => ({label : value, value}))],
    //   }, {
    //     group : 'Pricing Info',
    //     _id: 6,
    //     flex: 3,
    //     label: 'Estimated Price',
    //     name: 'estimate',
    //     type: 'text',
    //     placeholder: '0.00'
    //   }, {
    //     group : 'Insurance Info',
    //     _id: 7,
    //     flex: 6,
    //     label: 'Claim Number',
    //     name: 'claim_number',
    //     type: 'text',
    //     placeholder: 'Claim #'
    //   }, {
    //     group : 'Insurance Info',
    //     _id: 8,
    //     flex: 3,
    //     label: 'Insurance Company',
    //     name: 'insurance_company',
    //     type: 'text',
    //     placeholder: 'Farmers, Allstate, Geico'
    //   }, {
    //     group : 'Insurance Info',
    //     _id: 9,
    //     flex: 12,
    //     label: 'Description',
    //     name: 'description',
    //     type: 'textarea',
    //     placeholder: 'Description of required work'
    //   }
    // ];

    return (
      <FieldList
        readOnly={this.props.readOnly}
        entity={this.props.entity || this.state}
        fields={fields}
        onChange={this.props.onChange || this.handleChange}
      />
    )
  }
}

JobForm.propTypes = {

}

const mapStateToProps = ({jobs, fields}) => ({jobs, fields: fields['Job'] });

export default connect(mapStateToProps, Actions)(JobForm);



// WEBPACK FOOTER //
// ./src/browser/components/client/jobs/job-form.js